class UploadBlock {
    constructor(el) {
        this.el = el;

        this.init();
    }

    init() {
        this.filePreview = this.el.querySelector('.upload-block__preview');
        this.fileField = this.el.querySelector('.upload-block__file-field');
        this.dummyField = this.el.querySelector('.upload-block__dummy-field');
        this.deleteButton = this.el.querySelector('.upload-block__delete-btn');

        if(this.fileField && this.dummyField) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.onUploadFn = this.onUpload.bind(this);
        this.onUploadCompleteFn = this.onUploadComplete.bind(this);
        this.onFileDeletionFn = this.onFileDeletion.bind(this);
        this.onFileDeletionCompleteFn = this.onFileDeletionComplete.bind(this);

        this.fileField.addEventListener('change', this.onUploadFn);
        
        if(this.deleteButton) {
            this.deleteButton.addEventListener('click', this.onFileDeletionFn);
        }
    }

    onUpload() {
        const filenames = [];
        
        [...this.fileField.files].forEach((file) => {
            filenames.push(file.name);
        });
        
        this.dummyField.setAttribute('data-placeholder', this.dummyField.getAttribute('placeholder'));
        this.dummyField.setAttribute('placeholder', filenames.join(', '));

        if(this.filePreview) {
            const reader  = new FileReader();
            const file = this.fileField.files[0];
            reader.onloadend = this.onUploadCompleteFn.bind(this, reader);

            if(file) {
                reader.readAsDataURL(file);
            }
            else {
                this.onImageDeletion();
            }
        }
    }

    onUploadComplete(reader) {
        if(this.filePreview) {
            const img = document.createElement('img');
            img.src = reader.result;
            
            this.filePreview.append(img);
            this.deleteButton.classList.remove('d-none');
        }
    }

    onFileDeletion() {
        if(!this.deleteButton.hasAttribute('data-id') || !this.deleteButton.hasAttribute('data-action')) {
            return;
        }

        const id = this.deleteButton.getAttribute('data-id');
        const action = this.deleteButton.getAttribute('data-action');
        
        if(id && action) {
            $.post(ajaxurl, {action, id}, this.onFileDeletionCompleteFn);
        }
    }

    onFileDeletionComplete() {
        const preview = this.filePreview.querySelector('img');
        this.dummyField.setAttribute('placeholder', this.dummyField.getAttribute('data-placeholder'));
        
        if(preview) {
            preview.remove();
            this.deleteButton.classList.add('d-none');
        }

        this.fileField.value = '';
    }
}

export default UploadBlock;